import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { MerchSizes } from './constants';
import { buildMerchStoreConfig } from '../storeAliasHelper';
import { data_STAGING } from './STAGING';

export const EvolveToCyborgTshirtWhiteProduct = {
  title: "'Evolve to Cyborg' White T-shirt",
  description: '100% organic Supima cotton. Made carbon neutral.',
  imgSrc: 'web_v2/all-products/merch/new/evo-to-cyborg-tee-white.png/w_1920',
  shopifyProductName: 'Evolve to Cyborg T-shirt',
  availableSizes: [
    MerchSizes.S,
    MerchSizes.M,
    MerchSizes.L,
    MerchSizes.XL,
    MerchSizes.XXL,
  ],
};

export const EvolveToCyborgTshirtWhiteShopifyMap: Record<
  ShopifyStore,
  {
    price: number;
    sizes: Record<MerchSizes, { variantId: string; checkoutUrl: string }>;
  }
> =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? buildMerchStoreConfig<MerchSizes>({
        [ShopifyStore.AE]: {
          price: 95,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/44691325649138',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325649138:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/44691325714674',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325714674:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/44691325780210',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325780210:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/44691325812978',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325812978:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/44691325911282',
              checkoutUrl:
                'https://ultrahuman-mena.myshopify.com/cart/44691325911282:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.US]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40200406106208',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406106208:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40200406171744',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406171744:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40200406237280',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406237280:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40200406302816',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406302816:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40200406368352',
              checkoutUrl:
                'https://stelcore-x-ultrahuman.myshopify.com/cart/40200406368352:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.ROW]: {
          price: 25,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40718621147196',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621147196:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40718621212732',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621212732:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40718621278268',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621278268:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40718621343804',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621343804:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40718621409340',
              checkoutUrl:
                'https://ultrahuman-us.myshopify.com/cart/40718621409340:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.IN]: {
          price: 1599,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/40737965244486',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965244486:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/40737965310022',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965310022:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/40737965375558',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965375558:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/40737965441094',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965441094:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/40737965506630',
              checkoutUrl:
                'https://ultrahumanstore.myshopify.com/cart/40737965506630:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.EU]: {
          price: 23,
          sizes: {
            [MerchSizes.XS]: {
              variantId: '',
              checkoutUrl: '',
            },
            [MerchSizes.S]: {
              variantId: 'gid://shopify/ProductVariant/49202718998846',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202718998846:1?channel=buy_button',
            },
            [MerchSizes.M]: {
              variantId: 'gid://shopify/ProductVariant/49202719064382',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719064382:1?channel=buy_button',
            },
            [MerchSizes.L]: {
              variantId: 'gid://shopify/ProductVariant/49202719129918',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719129918:1?channel=buy_button',
            },
            [MerchSizes.XL]: {
              variantId: 'gid://shopify/ProductVariant/49202719228222',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719228222:1?channel=buy_button',
            },
            [MerchSizes.XXL]: {
              variantId: 'gid://shopify/ProductVariant/49202719293758',
              checkoutUrl:
                'https://ultrahuman-eu-uk.myshopify.com/cart/49202719293758:1?channel=buy_button',
            },
          },
        },
        [ShopifyStore.GB]: {
          price: 20,
        },
        [ShopifyStore.AU]: {
          price: 38,
        },
        [ShopifyStore.CA]: {
          price: 35,
        },
        [ShopifyStore.MX]: {
          price: 534,
        },
        [ShopifyStore.SA]: {
          price: 109,
        },
        [ShopifyStore.ZA]: {
          price: 499,
        },
        [ShopifyStore.JP]: {
          price: 3800,
        },
      })
    : data_STAGING;
